import { getValue } from './ConfigProvider'

const toBoolean = value => value === true || value === 'true'

export const availabilityIsEnabled = ({
  cookieVariant = '2', // 1 = variant, 2 = control
  pageType = 'search',
  isClearance = false,
  isWhiteGoods = false
} = {}) => {
  const isBrandEnabled = getValue('features.availability.enabled') || false
  const isTestVariant = cookieVariant === '1'
  const isDirectory = pageType === 'directory'
  const isPageIncluded = !isDirectory && !isClearance && !isWhiteGoods

  let isEnvironmentEnabled

  if (typeof window !== 'undefined') {
    isEnvironmentEnabled = toBoolean(window.availabilityEnabled)
  } else {
    isEnvironmentEnabled = toBoolean(process.env.AVAILABILITY_ENABLED)
  }

  return isBrandEnabled && isEnvironmentEnabled && isTestVariant && isPageIncluded
}
